import request from '@/utils/request'
import URL from './urlTranslator'

/**
 * // 走V1打印或者预览之前，先进行模板验证，判断该模板是否存在
 */
export function checkTemplateExist(templateName) {
  return request({
    url: URL.report.checkTemplateExist,
    method: 'get',
    params: { templateName: templateName }
  })
}

/**
 * 获取报表树
 */
export function reportTree(params) {
  return request({
    url: URL.report.reportTree,
    method: 'get',
    params
  })
}
